/* Maxari home — scripturi pentru secțiunile mx-* (hero cu telefon, clipuri TikTok, bară jos).
   Se încarcă o singură dată chiar dacă mai multe secțiuni îl includ. */
(function(){
  if(window.__mxHomeInit)return;window.__mxHomeInit=true;

  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function tryPlay(v){var p=v.play();if(p&&p.catch)p.catch(function(){})}
  // Hero: nu descărcăm clipul până nu s-a încărcat restul paginii (poza de start acoperă intervalul)
  function afterLoad(fn){if(document.readyState==='complete'){fn()}else{window.addEventListener('load',function(){setTimeout(fn,300)},{once:true})}}

  function init(){
    // ---- Video: se încarcă și pornesc doar când intră în ecran
    var vids=Array.prototype.slice.call(document.querySelectorAll('video[data-mx-autoplay]'));
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          var v=en.target,reel=v.closest('.mx-reel');
          v.dataset.visible=(en.isIntersecting&&en.intersectionRatio>0.35)?'1':'0';
          if(v.dataset.visible==='1'){
            if(!reduced||v.dataset.userPlayed){
              var go=function(){if(v.dataset.visible==='1'){tryPlay(v);if(reel)reel.classList.remove('is-paused')}};
              if(v.closest('[data-mx-hero]'))afterLoad(go);else go();
            }
            else if(reel)reel.classList.add('is-paused');
          }else{v.pause();if(reel&&reel.classList.contains('is-unmuted')){v.muted=true;reel.classList.remove('is-unmuted')}}
        });
      },{threshold:[0,0.35,0.6]});
      vids.forEach(function(v){io.observe(v)});
    }else{vids.forEach(function(v){v.dataset.visible='1';tryPlay(v)})}

    // ---- Hero: telefonul rulează clipurile din listă, ca pe TikTok (atinge pentru următorul)
    Array.prototype.slice.call(document.querySelectorAll('[data-mx-hero]')).forEach(function(root){
      var plEl=root.querySelector('script[type="application/json"]');
      var hv=root.querySelector('video');
      if(!plEl||!hv)return;
      var pl;try{pl=JSON.parse(plEl.textContent)}catch(e){return}
      if(!pl.length)return;
      var phone=root.querySelector('.mx-phone'),segs=Array.prototype.slice.call(root.querySelectorAll('.mx-phone__progress i'));
      var tag=root.querySelector('.mx-phone__tag'),tImg=root.querySelector('[data-tag-img]'),tName=root.querySelector('[data-tag-name]'),tPrice=root.querySelector('[data-tag-price]');
      var idx=0,skipTimer=null;
      function show(i){
        idx=(i+pl.length)%pl.length;var c=pl[idx];
        if(skipTimer){clearTimeout(skipTimer);skipTimer=null}
        if(!c.src&&pl.some(function(x){return x.src})){skipTimer=setTimeout(function(){show(idx+1)},3000)}
        segs.forEach(function(s,j){s.classList.toggle('done',j<idx);s.classList.toggle('active',j===idx);s.style.setProperty('--mx-p',0)});
        if(tag){tag.href=c.url||'#';if(tImg&&c.img)tImg.src=c.img;if(tName)tName.textContent=c.name||'';if(tPrice)tPrice.textContent=c.price||''}
        if(c.poster)hv.poster=c.poster;
        if(c.src){hv.src=c.src;hv.load();if(hv.dataset.visible!=='0'&&(!reduced||hv.dataset.userPlayed))tryPlay(hv)}
      }
      hv.addEventListener('ended',function(){show(idx+1)});
      if(!pl[0].src&&pl.some(function(x){return x.src})){skipTimer=setTimeout(function(){show(1)},3000)}
      hv.addEventListener('timeupdate',function(){if(hv.duration&&segs[idx])segs[idx].style.setProperty('--mx-p',Math.min(1,hv.currentTime/hv.duration))});
      hv.addEventListener('click',function(){hv.dataset.userPlayed='1';show(idx+1)});
      var snd=root.querySelector('.mx-phone__sound');
      if(snd)snd.addEventListener('click',function(e){e.preventDefault();hv.muted=!hv.muted;phone.classList.toggle('is-unmuted',!hv.muted);hv.dataset.userPlayed='1';tryPlay(hv)});
    });

    // ---- Reels: sunet pe un singur clip odată + play/pauză la tap
    var reels=Array.prototype.slice.call(document.querySelectorAll('.mx-reel'));
    reels.forEach(function(reel){
      var v=reel.querySelector('video'),btn=reel.querySelector('.mx-reel__sound'),play=reel.querySelector('.mx-reel__play');
      if(!v)return;
      if(btn)btn.addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();
        var wasMuted=v.muted;
        reels.forEach(function(r){var rv=r.querySelector('video');if(rv){rv.muted=true}r.classList.remove('is-unmuted')});
        if(wasMuted){v.muted=false;reel.classList.add('is-unmuted');v.dataset.userPlayed='1';reel.classList.remove('is-paused');tryPlay(v)}
      });
      if(play)play.addEventListener('click',function(){v.dataset.userPlayed='1';reel.classList.remove('is-paused');tryPlay(v)});
      v.addEventListener('click',function(){
        if(v.paused){v.dataset.userPlayed='1';reel.classList.remove('is-paused');tryPlay(v)}else{v.pause();reel.classList.add('is-paused')}
      });
    });

    // ---- Bara de jos (telefon): spațiu sub pagină + secțiunea activă
    var tabbar=document.querySelector('.mx-tabbar');
    if(tabbar){
      document.body.classList.add('mx-has-tabbar');
      var tabs=Array.prototype.slice.call(tabbar.querySelectorAll('a[href^="#"]'));
      if('IntersectionObserver' in window&&tabs.length){
        var map={};tabs.forEach(function(t){var id=t.getAttribute('href').slice(1);var el=document.getElementById(id);if(el)map[id]=t});
        var tio=new IntersectionObserver(function(entries){
          entries.forEach(function(en){if(en.isIntersecting&&map[en.target.id]){tabs.forEach(function(t){t.classList.remove('is-active')});map[en.target.id].classList.add('is-active')}});
        },{rootMargin:'-40% 0px -50% 0px'});
        Object.keys(map).forEach(function(id){tio.observe(document.getElementById(id))});
      }
    }
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  // în editorul de temă Shopify secțiunile se reîncarcă: reinițializăm
  document.addEventListener('shopify:section:load',function(){window.__mxHomeInit=true;init()});
})();
